import { render, staticRenderFns } from "./InventoryOverview.vue?vue&type=template&id=dc0590be&scoped=true"
import script from "./InventoryOverview.vue?vue&type=script&lang=js"
export * from "./InventoryOverview.vue?vue&type=script&lang=js"
import style0 from "./InventoryOverview.vue?vue&type=style&index=0&id=dc0590be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0590be",
  null
  
)

export default component.exports